import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../services/item';
import { canEditItemForItem } from '../../utils/item';
import { isEditable } from '../../utils/roles';
import { saveAll } from '../../store/items';

export const InputLabel = props => {
  const { itemId, placeholder, style, className } = props;
  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const canEdit = canEditItemForItem(item, items);

  const dispatch = useDispatch();

  const [value, setValue] = useState(item?.label);

  const textareaRef = useRef(null);

  useEffect(() => {
    item?.label && setValue(item?.label);
  }, [item?.label]);

  useEffect(() => {
    textareaRef.current.style.height = '0px';
    const scrollHeight = textareaRef.current.scrollHeight;
    textareaRef.current.style.height = scrollHeight + 'px';
  }, [value, textareaRef]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '0px';
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, []);

  const updateLabel = () => {
    if (!canEdit) {
      return;
    }
    dispatch(saveAll({ item, key: 'label', value }));

    update(`items/${itemId}`, 'label', value);
  };

  return (
    <textarea
      ref={textareaRef}
      rows={1}
      className={`text-center bg-transparent w-full font-condensed text-2xl p-05 ${className}`}
      style={style}
      placeholder={placeholder}
      value={value || ''}
      onChange={e => setValue(e.target.value)}
      onBlur={() => updateLabel()}
      disabled={isEditable() === false || !canEdit}
    ></textarea>
  );
};
